module.exports = __webpack_public_path__ + "img/2550c83.png";